import { formatCurrency } from '@/shared/lib/format';
import type { StatusVariant } from '@/shared/components/status-badge';

import type { CouponBrand, CouponStatus } from '../types/coupons.types';

/** e.g. "10% · max ₪20.00". Formatting only — the discount is always calculated by the backend. */
export function formatCouponValue(
  coupon: { percentOff: number; maxDiscountAmount: number | null },
  currency: string | null,
): string {
  const percent = `${coupon.percentOff}%`;
  return coupon.maxDiscountAmount === null
    ? percent
    : `${percent} · max ${formatCurrency(coupon.maxDiscountAmount, currency ?? undefined, { precise: true })}`;
}

export function formatCouponScope(coupon: { appliesToAllBrands: boolean; brands: CouponBrand[] }) {
  return coupon.appliesToAllBrands ? 'All brands' : coupon.brands.map((b) => b.name).join(', ');
}

export const COUPON_STATUS: Record<CouponStatus, { label: string; variant: StatusVariant }> = {
  active: { label: 'Active', variant: 'success' },
  scheduled: { label: 'Scheduled', variant: 'info' },
  expired: { label: 'Expired', variant: 'neutral' },
  inactive: { label: 'Inactive', variant: 'neutral' },
};
